module.exports = __webpack_public_path__ + "img/product-placeholder-3.88b24d9.png";